import { Button, CircularProgress } from '@mui/material'

const CustomeButton = ({ text, width, loading, sx = {}, ...props }) => {
  return (
    <Button
      variant='contained'
      color='primary'
      sx={{
        marginBottom: 2,
        color: 'white',
        borderRadius: '20px',
        width: width,
        textTransform: 'none',
        boxShadow: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...props}>
      {loading && (
        <CircularProgress color='inherit' size={20} sx={{ marginRight: 1 }} />
      )}
      {text}
    </Button>
  )
}

export default CustomeButton
